import { render, staticRenderFns } from "./DeliveryRequests.vue?vue&type=template&id=67d04322"
import script from "./DeliveryRequests.vue?vue&type=script&lang=js"
export * from "./DeliveryRequests.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRequests.vue?vue&type=style&index=0&id=67d04322&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports